export default "__VITE_ASSET__OzRxJQRh__"